import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function WhatsAppFloat() {
  const [num, setNum] = useState("");
  useEffect(() => {
    api.get("/site/config").then((r) => setNum(r.data.whatsapp)).catch(() => {});
  }, []);
  if (!num) return null;
  const href = `https://wa.me/${num.replace(/[^0-9]/g, "")}?text=${encodeURIComponent("Hello Maklan Motors, I'd like to enquire about a vehicle.")}`;
  return (
    <a
      data-testid="whatsapp-float"
      href={href} target="_blank" rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#C5A059] text-[#050814] flex items-center justify-center shadow-[0_10px_40px_-10px_rgba(197,160,89,0.6)] hover:scale-110 transition-transform duration-500"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={22} />
    </a>
  );
}
